import { useRef, useLayoutEffect, useState } from 'react'
import useLoading from '#Context/Loading'
import { useLocation } from 'react-router-dom'; 
import { drawBGImg1, drawBGImg2 } from './drawImgs'

//BG Images
import journey6 from '../imgs/journey6.jpg'
import rocks1 from '../imgs/rocks1.jpg'
import journey9 from '../imgs/journey9.jpg'
import working5 from '../imgs/working5.jpg'
import working7 from '../imgs/working7.jpg'
import motorcycle1 from '../imgs/motorcycle1.jpg'
import library2 from '../imgs/library2.jpg'
import working12 from '../imgs/working12.jpg'
import journey17 from '../imgs/journey17.jpg'
import working15 from '../imgs/working15.jpg'
import working2 from '../imgs/working2.png'
import city1 from '../imgs/city1.jpg'
import journey20 from '../imgs/journey20.jpg';
import working10 from '../imgs/working10.jpg';
import engine2 from '../imgs/engine2.jpg';
import journey15 from '../imgs/journey15.jpg';
import tech2 from '../imgs/tech2.jpg';
import journey18 from '../imgs/journey18.jpg';
import working17 from '../imgs/working17.jpg';
import journey3 from '../imgs/journey3.jpg';
import circuit3 from '../imgs/circuit3.jpg';

export default function useBGImages(platform, dimensions, paths, canvas) {
    // console.log('useBGImages hook')
    const location = useLocation()
    const path = location.pathname.split('/')[1]
    const { suspend, promise, error, mounted } = useLoading(); 
    const imgCache = useRef({}); 

    // if (!dimensions || !mounted) return;
    if (!dimensions) return;

    let name1, name2, url1, url2;
    switch (platform) {
    case 'desktop':
        switch (path) {
        case 'resume':
            name1 = 'journey6'; url1 = journey6;
            name2 = 'rocks1'; url2 = rocks1
            break;
        case 'about':
            name1 = 'journey9'; url1 = journey9
            name2 = 'working5'; url2 = working5
            break;
        case 'projects':
            name1 = 'working7'; url1 = working7
            name2 = 'motorcycle1'; url2 = motorcycle1
            break;
        case 'blog':
            name1 = 'library2'; url1 = library2
            name2 = 'working12'; url2 = working12
            break;
        case 'contact':
            name1 = 'journey17'; url1 = journey17
            name2 = 'working15'; url2 = working15
            break;
        case '':
        default: //also catches any 404 routes
            name1 = 'working2'; url1 = working2
            name2 = 'city1'; url2 = city1
            break;
        }
        break;
    case 'mobile':
    case 'tablet':
    default:
        switch (path) {
        case 'resume':
            name1 = 'journey20'; url1 = journey20
            name2 = 'motorcycle1'; url2 = motorcycle1
            break;
        case 'about':
            name1 = 'journey9'; url1 = journey9
            name2 = 'working5'; url2 = working5
            break;
        case 'projects':
            name1 = 'working10'; url1 = working10
            name2 = 'engine2'; url2 = engine2
            break;
        case 'blog':
            name1 = 'journey15'; url1 = journey15
            name2 = 'tech2'; url2 = tech2
            break;
        case 'contact':
            name1 = 'journey18'; url1 = journey18
            name2 = 'working17'; url2 = working17
            break;
        case '':
        default:
            name1 = 'journey3'; url1 = journey3
            name2 = 'circuit3'; url2 = circuit3
            break;
        }
        break;
    }
    let img1 = imgCache.current[name1]; 
    let img2 = imgCache.current[name2];
    if (img1 && img2) {
        drawBGImg1(img1, canvas.current, dimensions, paths, location, platform)
        drawBGImg2(img2, canvas.current, dimensions, paths, location, platform)
        return; 
    }
    if (!img1) {
        img1 = new Promise((resolve, reject) => {
            // setTimeout(() => resolve('finished!'), 3000)
            let bgImg = new Image()
            bgImg.src = url1;
            imgCache.current[name1] = bgImg;
            bgImg.onload = () => resolve(bgImg)
            bgImg.onerror = (e) => reject(e)
        })
    }
    if (!img2) {
        img2 = new Promise((resolve, reject) => {
            // setTimeout(() => reject(new Error('damnit!')), 3000)
            let bgImg = new Image()
            bgImg.src = url2;
            imgCache.current[name2] = bgImg;
            bgImg.onload = () => resolve(bgImg)
            bgImg.onerror= (e) => reject(e)
        })
    }
    suspend.current = true; 
    promise.current = Promise.all([img1, img2])
        .then(imgs => {
            drawBGImg1(imgs[0], canvas.current, dimensions, paths, location, platform)
            drawBGImg2(imgs[1], canvas.current, dimensions, paths, location, platform)
        })
        .catch(e => {
            console.log(e); 
            error.current = e
        })
        .finally(() => {
            suspend.current = false; 
            promise.current = false; 
        })
}